import { Link } from 'react-router-dom';
import { usePrivacySettings } from '@/hooks/usePrivacySettings';
import { usePosts } from '@/hooks/usePosts';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import Seo from '@/components/base/Seo';

export default function PrivacyPage() {
  const { settings } = usePrivacySettings();
  const { getPublishedPosts } = usePosts();
  const allPosts = getPublishedPosts();

  return (
    <div className="min-h-screen bg-background-50 font-body">
      <Seo title="Política de Privacidade" description="Saiba como o Miau de Casa utiliza dados, cookies, Google AdSense e protege a privacidade dos visitantes." path="/privacidade" />
      <Navbar />

      {/* Hero */}
      <section className="w-full bg-background-100 py-12 md:py-16 lg:py-20">
        <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
          <nav className="flex items-center justify-center gap-2 mb-4 text-foreground-400 text-xs">
            <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">Início</Link>
            <i className="ri-arrow-right-s-line text-sm"></i>
            <span className="text-foreground-600">{settings.pageTitle}</span>
          </nav>
          <h1 className="font-heading font-black text-foreground-950 text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-tight mb-3 md:mb-4 animate-fade-in-up">
            {settings.pageTitle}
          </h1>
          <p className="text-foreground-500 text-sm md:text-base animate-fade-in-up" style={{ animationDelay: '100ms', animationFillMode: 'both' }}>
            {settings.pageSubtitle}
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="w-full bg-background-50 py-12 md:py-16 lg:py-20">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <article className="space-y-8 md:space-y-10">
            {settings.sections.map((section, i) => (
              <div
                key={i}
                className="animate-fade-in-up"
                style={{ animationDelay: `${i * 70}ms`, animationFillMode: 'both' }}
              >
                <h2 className="font-heading font-bold text-foreground-950 text-lg md:text-xl mb-3">
                  {section.title}
                </h2>
                <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                  {section.content}
                </p>
              </div>
            ))}
            <div className="animate-fade-in-up">
              <h2 className="font-heading font-bold text-foreground-950 text-lg md:text-xl mb-3">
                Publicidade e Google AdSense
              </h2>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                Este site utiliza o Google AdSense para exibir anúncios. O Google e seus parceiros podem usar cookies para veicular e personalizar anúncios com base nas visitas a este e a outros sites. Você pode consultar e controlar a personalização de anúncios nas configurações de anúncios do Google. O tratamento desses dados observa esta Política de Privacidade e a legislação aplicável.
              </p>
            </div>
          </article>

          {/* Back to contact link */}
          <div className="mt-12 md:mt-16 pt-8 border-t border-background-200 text-center">
            <p className="text-foreground-500 text-sm mb-4">
              Ainda tem dúvidas? Entre em contato conosco.
            </p>
            <Link
              to="/contato"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white text-sm font-bold px-5 py-2.5 rounded-full transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-send-line"></i>
              Fale Conosco
            </Link>
          </div>
        </div>
      </section>

      <Footer popularPosts={allPosts} />
    </div>
  );
}
